import { useRoutes, RouteObject, Outlet, Navigate } from 'react-router-dom';

import LocationInfo from '~/pages/MealBoxRecycling/LocationInfo';
import ReturnRecord from '~/pages/MealBoxRecycling/ReturnRecord';
import PickMealLocationInfo from '~/pages/PickMealLocationInfo';
import ReturnList from '~/pages/MealBoxRecycling/ReturnList';
import MealBoxRecycling from '~/pages/MealBoxRecycling';
import GroupBuyCreate from '~/pages/GroupBuyCreate';
import GroupBuyShare from '~/pages/GroupBuyShare';
import MemberCenter from '~/pages/MemberCenter';
import StoreInfo from '~/pages/Store/StoreInfo';
import EditItem from '~/pages/Item/EditItem';
import FilterMeal from '~/pages/FilterMeal';
import SearchItem from '~/pages/SearchItem';
import SearchStore from '~/pages/SearchStore';
import AddItem from '~/pages/Item/AddItem';
import StoreList from '~/pages/StoreList';
import ItemList from '~/pages/ItemList';
import OrderList from '~/pages/OrderList';
import Store from '~/pages/Store';
import Home from '~/pages/Home';
import Cart from '~/pages/Cart';
// import Coupon from '~/pages/Coupon';
import CouponDetail from '~/pages/CouponDetail';

import PlatformProvider from '~/provider/PlatformProvider';
import PersonalProvider from '~/provider/PersonalProvider';
import GroupBuyProvider from '~/provider/GroupBuyProvider';
import StoreProvider from '~/pages/Store/StoreProvider';
import AuthProvider from '~/provider/AuthProvider';
import DisplayStoresProvider from '~/provider/DisplayStoresProvider';
import HomePage from '~/pages/EnterpriseGroupBuy/Home';
import EnterpriseGroupBuyProvider from '~/provider/EnterpriseGroupBuyProvider';
import LineLogin from '~/pages/LineLogin';
import EnterpriseGroupBuyOrderRedirect from '~/pages/EnterpriseGroupBuyOrderRedirect';

const routes: Array<RouteObject> = [
  {
    path: '',
    element: (
      <PlatformProvider>
        <AuthProvider>
          <Outlet />
        </AuthProvider>
      </PlatformProvider>
    ),
    children: [
      {
        path: '',
        element: (
          <PersonalProvider>
            <Outlet />
          </PersonalProvider>
        ),
        children: [
          {
            path: '',
            element: <Home />,
          },
          // {
          //   path: 'filterMeal',
          //   element: <FilterMeal />,
          // },
          { path: 'searchItem', element: <SearchItem /> },
          { path: 'searchStore', element: <SearchStore /> },
          {
            path: 'pickMealLocationInfo/:pointId',
            element: <PickMealLocationInfo />,
          },
          {
            path: 'store/:storeId/item/:itemId',
            children: [
              {
                path: 'add',
                element: <AddItem />,
              },
              {
                path: 'edit/:keyId',
                element: <EditItem />,
              },
            ],
          },
          {
            path: 'storeList',
            element: <StoreList />,
          },
          { path: 'itemList', element: <ItemList /> },
          {
            path: 'store/:storeId',
            element: (
              <StoreProvider>
                <Outlet />
              </StoreProvider>
            ),
            children: [
              {
                path: '',
                element: <Store />,
              },
              {
                path: 'info',
                element: <StoreInfo />,
              },
            ],
          },
          {
            path: 'memberCenter',
            element: <MemberCenter />,
          },
          {
            path: 'orderList',
            element: <OrderList />,
          },
          {
            path: 'mealBoxRecycling',
            children: [
              {
                path: '',
                element: <MealBoxRecycling />,
              },
              {
                path: 'returnList',
                element: <ReturnList />,
              },
              {
                path: 'locationInfo/:locationId',
                element: <LocationInfo />,
              },
              {
                path: 'returnRecord',
                element: <ReturnRecord />,
              },
            ],
          },
          {
            path: 'cart',
            element: (
              <DisplayStoresProvider>
                <Cart />
              </DisplayStoresProvider>
            ),
          },
          {
            path: 'memberCenter',
            element: (
              <DisplayStoresProvider>
                <Outlet />
              </DisplayStoresProvider>
            ),
            children: [
              {
                path: '',
                element: <MemberCenter />,
              },

              {
                path: ':id',
                element: <CouponDetail />,
              },
            ],
          },
          {
            path: 'groupBuy',
            element: <GroupBuyCreate />,
          },
        ],
      },
      // enterprise group buy routes
      {
        path: 'enterpriseGroupBuy',
        element: (
          <EnterpriseGroupBuyProvider>
            <Outlet />
          </EnterpriseGroupBuyProvider>
        ),
        children: [
          {
            path: ':enterpriseGroupBuyId',
            children: [
              {
                path: '',
                element: <HomePage />,
              },
              {
                path: 'store/:storeId/item/:itemId',
                children: [
                  {
                    path: 'add',
                    element: <AddItem />,
                  },
                  {
                    path: 'edit/:keyId',
                    element: <EditItem />,
                  },
                ],
              },
              {
                path: 'cart',
                element: <Cart />,
              },
              {
                path: 'orderList',
                element: <OrderList />,
              },
            ],
          },
        ],
      },
      {
        path: 'enterpriseGroupBuy-redirect',
        element: <EnterpriseGroupBuyOrderRedirect />,
      },
      // group buy routes
      {
        path: 'group/:groupId',
        element: (
          <GroupBuyProvider>
            <Outlet />
          </GroupBuyProvider>
        ),
        children: [
          {
            path: '',
            element: <Home />,
          },
          { path: 'searchItem', element: <SearchItem /> },
          { path: 'searchStore', element: <SearchStore /> },
          {
            path: 'pickMealLocationInfo/:pointId',
            element: <PickMealLocationInfo />,
          },
          {
            path: 'store/:storeId/item/:itemId',
            children: [
              {
                path: 'add',
                element: <AddItem />,
              },
              {
                path: 'edit/:keyId',
                element: <EditItem />,
              },
            ],
          },
          {
            path: 'storeList',
            element: <StoreList />,
          },
          { path: 'itemList', element: <ItemList /> },
          {
            path: 'store/:storeId',
            element: (
              <StoreProvider>
                <Outlet />
              </StoreProvider>
            ),
            children: [
              {
                path: '',
                element: <Store />,
              },
              {
                path: 'info',
                element: <StoreInfo />,
              },
            ],
          },
          {
            path: 'memberCenter',
            element: <MemberCenter />,
          },
          {
            path: 'orderList',
            element: <OrderList />,
          },
          {
            path: 'mealBoxRecycling',
            children: [
              {
                path: '',
                element: <MealBoxRecycling />,
              },
              {
                path: 'returnList',
                element: <ReturnList />,
              },
              {
                path: 'locationInfo/:locationId',
                element: <LocationInfo />,
              },
              {
                path: 'returnRecord',
                element: <ReturnRecord />,
              },
            ],
          },
          {
            path: 'cart',
            element: (
              <DisplayStoresProvider>
                <Cart />
              </DisplayStoresProvider>
            ),
          },
          {
            path: 'memberCenter',
            element: (
              <DisplayStoresProvider>
                <Outlet />
              </DisplayStoresProvider>
            ),
            children: [
              {
                path: '',
                element: <MemberCenter />,
              },

              {
                path: ':id',
                element: <CouponDetail />,
              },
            ],
          },
          {
            path: 'groupBuy',
            element: <GroupBuyShare />,
          },
        ],
      },
      // Line Login
      { path: 'line-login', element: <LineLogin /> },
      {
        path: '*',
        element: <Navigate to="/" />,
      },
    ],
  },
];

export default function Routes() {
  const element = useRoutes(routes);

  return element;
}
